module.exports = __webpack_public_path__ + "b367c8ce55452eaca253a84425095db8.mp4";